import React from "react";
import { TableTrProps } from "./Table.types";
import { Tr as StyledTr } from "./Tr.styles";

/**
 * Table row component
 */
export const Tr = ({
  children,
  className,
  size,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ...props
}: TableTrProps) => (
  <StyledTr
    className={className}
    size={size}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    {...props}
  >
    {children}
  </StyledTr>
);
